<div nxRow class="policy-details" *ngIf="showSection">
    <div nxCol="12">
        <h3 nxHeadline="subsection-medium" translate>ma-insurance.details</h3>
        <nx-card>
            <ng-container [ngSwitch]="maInsurance.detailTypeIdentifier">
                <app-ma-insurance-car *ngSwitchCase="'CAR-INSURANCE'" [policyNumber]="policy.policyNumber"
                    [maInsurance]="maInsurance"  [showEdit]="showEdit"></app-ma-insurance-car>
                <app-ma-insurance-life *ngSwitchCase="'LIFE-INSURANCE'"
                    [maInsurance]="maInsurance" [agent]="agentForLife"></app-ma-insurance-life>

                <ng-container *ngSwitchCase="'TRAVEL-INSURANCE'">
                    <app-ma-insurance-travel *ngIf="loggedUser.role == role.Individual"
                        [maInsurance]="maInsurance"></app-ma-insurance-travel>
                    <app-ma-insurance-travel-rzcp *ngIf="loggedUser.role == role.LegalPerson"
                        [maInsurance]="maInsurance"></app-ma-insurance-travel-rzcp>
                </ng-container>
            </ng-container>
        </nx-card>
    </div>
</div>